export const Environment = {
    MS_USUARIOS_ESTABELECIMENTO:'https://app.spacefood.com.br/api/v1/usuarios/estabelecimento',
    MS_USUARIOS_RECUPERAR_SENHA:'https://app.spacefood.com.br/api/v1/usuarios/estabelecimento',
    MS_ESTABELECIMENTOS:'https://app.spacefood.com.br/api/v1/estabelecimento',
    MS_FINANCEIRO:'https://app.spacefood.com.br/api/v1/financeiro',
    MS_CLIENTES: 'https://app.spacefood.com.br/api/v1/estabelecimento/clientes',
    MS_PRODUTOS: "https://app.spacefood.com.br/api/v1/produtos",
    MS_PEDIDOS: "https://app.spacefood.com.br/api/v1/pedidos",
    MS_PEDIDOS_SOCKET: "https://app.spacefood.com.br",
    MS_MARKETPLACES: "https://app.spacefood.com.br/api/v1/marketplace",
    MS_MARKETPLACES_SOCKET: "https://chat.spacefood.com.br",
    MS_ENTREGADORES: 'https://app.spacefood.com.br/api/v1/estabelecimento/entregadores',
    TOKEN_KEY:"@token",
    TOKEN_ESTABELECIMENTO_KEY:"@defaultToken",
    TOKEN_RECUPERAR_SENHA_KEY: "@recoverPasswordToken",
    GOOGLE_PLACES_API: "AIzaSyAgCzwcD71xpSVfPzFzHQPKSGleaEn5kdA",
    UUID_SPACEFOOD: "6690e557-f4d7-447c-8e1b-de66837f4d0a"
}

